export default __webpack_public_path__ + "static/media/carousel2.67505972.png";